import { render, staticRenderFns } from "./ContactsEditor.vue?vue&type=template&id=2089129c&scoped=true"
import script from "./ContactsEditor.vue?vue&type=script&lang=js"
export * from "./ContactsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089129c",
  null
  
)

export default component.exports